import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DeletePopupComponent } from './delete-popup.component';
import { ButtonModule } from '@shared';
import { MatDialogModule } from '@angular/material/dialog';
import { LinkModule } from '../../link/link.module';
import {TranslateModule} from "@ngx-translate/core";

@NgModule({
  declarations: [DeletePopupComponent],
  imports: [CommonModule, ButtonModule, MatDialogModule, LinkModule, TranslateModule],
})
export class DeletePopupModule {}
